import { Link } from "react-router-dom";
import type { ServiceOfferingModel } from "./Functions";
export const ServiceCardPiece = ({ service, index = 0 }: { service: ServiceOfferingModel; index?: number }) => (
  <article className={`studio-service-card ${index === 0 ? "studio-service-featured" : ""}`}>
    <div className="studio-card-top"><span>0{index + 1} / OUR EXPERTISE</span><span aria-hidden="true">↗</span></div>
    <h2>{service.title}</h2><p>{service.summary}</p>
    <ul>{service.outcomes.map(outcome => <li key={outcome}>{outcome}</li>)}</ul>
    <Link to="/booking" className="studio-card-link">Let’s create this <span aria-hidden="true">→</span></Link>
  </article>
);
